import getOptionsTypeLabel from '../../getOptionsTypeLabel';
import type { Language, ProcessCellCallbackParams, SelectOption } from '../../../types/common';
import type { OptionsType } from '../../../types/options';

const organizationBaseIdCellCallback = (params: ProcessCellCallbackParams): string => {
  const code: string = params.value;
  const organizationBases: OptionsType[] = params.context?.organizationBase ?? [];
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const targetOrganizationBase: OptionsType | undefined = organizationBases.find((base) => base.code === String(code));
  const organizationBaseName: string = targetOrganizationBase ? getOptionsTypeLabel(targetOrganizationBase, currentLang.value) : code;
  return organizationBaseName;
};

export default organizationBaseIdCellCallback;
